import React from "react";
import useLockBodyScroll from "../hooks/layout/useLockBodyScroll";

const ModalOverlay = ({ children, className, style = {}, maskClosable = false, closeModal = () => {} }) => {
  useLockBodyScroll(true);
  return (
    <div className={className} style={style} role="dialog" onClick={maskClosable ? closeModal : undefined}>
      {children}
    </div>
  );
};

export default ModalOverlay;
